module.exports = __webpack_public_path__ + "img/alfa romeo.4aea373c.svg";